import {Component, OnInit, forwardRef, Input, AfterViewInit, Injector, ChangeDetectorRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';
import { TextareaModel } from '../textarea.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';

@Component({
    selector: 'abw-textarea-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TextareaFormComponent),
        multi: true
      }
    ],
    templateUrl: './textarea-form.component.html',
    styleUrls: ['./textarea-form.component.scss']
})
export class TextareaFormComponent extends AbstractWorkflowFormComponent<TextareaModel, string> {
  @Input() rows = 3;
}